(function () {
  'use strict';
  if (customElements.get('mnb-bike-search-results')) return;
  const encode = state => btoa(unescape(encodeURIComponent(JSON.stringify(state)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const label = state => [...state.constraints.map(c => c.label.replace(/ bikes$/i, '')), state.residual].filter(Boolean).join(' ');
  const node = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text !== undefined) el.textContent = text; return el; };
  // Filter definitions are kept together so the available controls can evolve.
  const budgetRanges = [
    { value: 'budget', label: 'Under £1,000', max: 999.99 },
    { value: 'mid-range', label: '£1,000–£2,000', min: 1000, max: 2000 },
    { value: 'high-end', label: 'Above £2,000', min: 2000.01 }
  ];
  const money = value => '£' + Number(value).toLocaleString('en-GB');
  const priceLabel = (min, max) => min !== undefined && max !== undefined ? money(min) + '–' + money(max) : min !== undefined ? 'From ' + money(min) : 'Up to ' + money(max);
  const filterDefinitions = [
    { kind: 'subcategory', label: 'Bike Type', empty: 'All bike types', missingOnly: true },
    { kind: 'size', label: 'Size', empty: 'All sizes', missingOnly: true },
    { kind: 'budget', label: 'Price range', empty: 'Any price', options: budgetRanges },
    { kind: 'brand', label: 'Brand', empty: 'All brands', missingOnly: true },
    { kind: 'condition', label: 'Condition', empty: 'All conditions', missingOnly: true },
    { kind: 'price_grade', label: 'Deals', empty: 'Any deal', options: [
      { value: 'incredible', label: 'Incredible price' },
      { value: 'great', label: 'Great price' },
      { value: 'good', label: 'Good price' }
    ] }
  ];
  class BikeResults extends HTMLElement {
    connectedCallback() {
      if (this.connected) return; this.connected = true; this.sequence = 0;
      this.input = this.querySelector('input[name="q"]'); this.status = this.querySelector('[data-search-status]'); this.grid = this.querySelector('ul.product-grid'); this.filters = this.querySelector('[data-search-filters]'); this.sort = this.querySelector('[data-search-sort]'); this.pagination = this.querySelector('[data-search-pagination]'); this.error = this.querySelector('[data-search-error]');
      this.refine = this.querySelector('[data-search-refine]');
      this.filterTrigger = this.querySelector('[data-open-filters]');
      this.filterSheet = this.querySelector('[data-filter-sheet]');
      this.filterFields = this.querySelector('[data-filter-fields]');
      this.filterClear = this.querySelector('[data-filter-clear]');
      this.filterApply = this.querySelector('[data-filter-apply]');
      this.filterCount = this.querySelector('[data-filter-count]');
      this.mobileQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;
      const sortControl = this.sort.closest('.bike-search-sort');
      const sortHome = sortControl?.parentElement;
      const filterBar = this.querySelector('[data-sheet-sort]');
      const positionSort = () => {
        if (sortControl && sortHome && filterBar) (this.mobileQuery?.matches ? filterBar : sortHome).append(sortControl);
      };
      positionSort();
      this.listeners = new AbortController(); const opts = { signal: this.listeners.signal };
      this.querySelector('form').addEventListener('submit', event => { if (event.defaultPrevented || this.querySelector('mnb-bike-search')?.selected >= 0) return; this.querySelector('mnb-bike-search')?.dismiss(); event.preventDefault(); const url = new URL(location.href); url.search = new URLSearchParams({ q: this.input.value.trim() }); this.navigate(url); }, opts);
      this.sort.addEventListener('change', () => { this.paintSortValue(); if (this.mobileQuery?.matches && this.filterSheet?.hidden === false) return; const url = new URL(location.href); url.searchParams.set('sort', this.sort.value); url.searchParams.delete('page'); this.navigate(url); }, opts);
      this.filters.addEventListener('click', event => { const button = event.target.closest('[data-remove-filter]'); if (button && this.state) this.removeFilter(button.dataset.removeFilter); }, opts);
      this.refine?.addEventListener('change', event => this.applyFilter(event.target), opts);
      this.pagination.addEventListener('click', event => { const link = event.target.closest('a'); if (link) { event.preventDefault(); this.navigate(new URL(link.href)); } }, opts);
      this.querySelector('[data-search-retry]').addEventListener('click', () => this.load(), opts);
      window.addEventListener('popstate', () => { this.filterSheet?.close(); this.load(); }, opts);
      this.filterTrigger?.addEventListener('click', () => {
        if (this.filterSheet?.hidden === false) { this.filterSheet.close(); return; }
        // Touch taps do not focus the button, so claim focus before the sheet
        // records its opener; closing then returns the user to Filters.
        this.filterTrigger.focus();
        this.openFilters();
      }, opts);
      this.querySelector('[data-filter-close]')?.addEventListener('click', () => this.filterSheet?.close(), opts);
      this.filterClear?.addEventListener('click', () => this.clearSheetFilters(), opts);
      this.filterApply?.addEventListener('click', () => this.applySheetFilters(), opts);
      this.filterFields?.addEventListener('change', event => this.onSheetChange(event), opts);
      this.filterSheet?.addEventListener('bottom-sheet:open', () => {
        this.filterTrigger?.setAttribute('aria-expanded', 'true');
        this.filterSheet.querySelector('#BikeSearchFiltersTitle')?.focus({ preventScroll: true });
      }, opts);
      this.filterSheet?.addEventListener('bottom-sheet:close', () => {
        this.sheetRequest?.abort();
        this.filterTrigger?.setAttribute('aria-expanded', 'false');
        this.sort.value = new URL(location.href).searchParams.get('sort') || 'relevance';
      }, opts);
      if (this.mobileQuery) {
        this.onBreakpointChange = () => { positionSort(); this.filterSheet?.close(); if (this.lastResult) this.renderRefinements(this.lastResult); };
        if (this.mobileQuery.addEventListener) this.mobileQuery.addEventListener('change', this.onBreakpointChange);
        else this.mobileQuery.addListener?.(this.onBreakpointChange);
      }
      if (typeof ResizeObserver !== 'undefined') {
        this.badgeObserver = new ResizeObserver(() => this.trimBadges());
        this.badgeObserver.observe(this.grid);
      }
      document.fonts?.ready.then(() => { if (this.isConnected) this.trimBadges(); });
      this.load();
    }
    disconnectedCallback() {
      this.sheetRequest?.abort();
      this.connected = false; this.sequence++; this.listeners?.abort(); this.badgeObserver?.disconnect(); this.request?.abort(); clearTimeout(this.timeout);
      if (this.onBreakpointChange) {
        if (this.mobileQuery?.removeEventListener) this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
        else this.mobileQuery?.removeListener?.(this.onBreakpointChange);
      }
    }
    navigate(url) { history.pushState({}, '', url); this.load(); }
    removeFilter(key) {
      const keys = key.startsWith('price_') ? key.split('|') : [key];
      const removed = this.state.constraints.filter(c => keys.includes(c.key));
      if (!removed.length) return;
      const min = removed.find(c => c.kind === 'price_min')?.value;
      const max = removed.find(c => c.kind === 'price_max')?.value;
      const range = removed.every(c => ['price_min', 'price_max'].includes(c.kind)) && budgetRanges.find(range => range.min === min && range.max === max);
      this.commitFilters(this.state.constraints.filter(c => !keys.includes(c.key)), {
        action: 'remove', source: 'chip', filter_kind: range ? 'budget' : removed[0].kind,
        filter_value: range ? range.value : removed[0].value, filter_label: range ? range.label : removed[0].label
      });
    }
    commitFilters(constraints, interaction, sortValue) {
      const changed = constraints.length !== this.state.constraints.length || constraints.some(c => !this.state.constraints.some(previous => previous.key === c.key));
      const query = this.state.originalQuery;
      const state = { ...this.state, constraints, notices: [] };
      state.originalQuery = label(state);
      const url = new URL(location.href);
      if (sortValue !== undefined) url.searchParams.set('sort', sortValue);
      url.searchParams.set('q', state.originalQuery);
      url.searchParams.set('bike_state', encode(state));
      url.searchParams.delete('page');
      this.state = state;
      if (changed) (Array.isArray(interaction) ? interaction : interaction ? [interaction] : []).forEach(item => this.dispatchEvent(new CustomEvent('bike-search-filter-change', { bubbles: true, detail: {
        ...item, query, filters: constraints.map(({ kind, value, label }) => ({ kind, value, label }))
      } })));
      this.navigate(url);
    }
    applyFilter(select) {
      if (!this.state || !select.matches('[data-add-filter]')) return;
      const kind = select.dataset.addFilter;
      const replaced = kind === 'budget' ? ['price_min', 'price_max'] : [kind];
      const constraints = this.state.constraints.filter(c => !replaced.includes(c.kind));
      const add = (kind, value, label) => constraints.push({ kind, value, label, key: kind + ':' + value });
      if (kind === 'budget') {
        const range = budgetRanges.find(range => range.value === select.value);
        if (range?.min !== undefined) add('price_min', range.min, 'From £' + range.min.toLocaleString('en-GB'));
        if (range?.max !== undefined) add('price_max', range.max, 'Up to £' + range.max.toLocaleString('en-GB'));
      } else if (select.value) {
        add(kind, select.value, select.selectedOptions[0].dataset.label);
      }
      this.commitFilters(constraints, {
        action: select.value ? 'select' : 'clear', source: 'dropdown', filter_kind: kind,
        filter_value: select.value, filter_label: select.selectedOptions[0].dataset.label || select.selectedOptions[0].textContent
      });
    }
    renderRefinements(result) {
      if (!this.refine) return;
      this.lastResult = result;
      this.filterModel = this.buildFilterGroups(result);
      const focusedKind = this.refine.contains(document.activeElement) ? document.activeElement.dataset.addFilter : null;
      // Mobile replaces the inline controls with one sheet, so it never renders
      // the duplicate option nodes. A breakpoint change re-renders from lastResult.
      if (this.mobileQuery?.matches) {
        this.refine.replaceChildren();
        this.refine.hidden = true;
        this.updateFilterTrigger();
        return;
      }
      const controls = [];
      this.filterModel.filter(group => group.desktopVisible).forEach(({ definition, options, applied, range, custom }) => {
        const wrapper = node('label', 'bike-search-refine__field');
        wrapper.append(node('span', 'bike-search-refine__label', definition.label));
        const select = node('select'); select.dataset.addFilter = definition.kind;
        select.setAttribute('aria-label', definition.label);
        const empty = node('option', '', definition.empty); empty.value = ''; select.append(empty);
        options.forEach(option => {
          const el = node('option', '', option.label + (option.count !== undefined ? ' (' + option.count + ')' : ''));
          el.value = option.value; el.dataset.label = option.label; select.append(el);
        });
        if (definition.kind === 'budget') {
          if (custom) { const el = node('option', '', 'Custom price range'); el.value = 'custom'; el.disabled = true; select.append(el); select.value = 'custom'; }
          else if (range) select.value = range.value;
        } else if (applied) select.value = String(applied.value);
        select.disabled = !options.length;
        const control = node('span', 'bike-search-refine__control');
        control.append(select);
        const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        caret.setAttribute('viewBox', '0 0 12 12'); caret.setAttribute('fill', 'none'); caret.setAttribute('stroke', 'currentColor'); caret.setAttribute('stroke-width', '1.5'); caret.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS(caret.namespaceURI, 'path'); path.setAttribute('d', 'm3 4.5 3 3 3-3'); caret.append(path); control.append(caret);
        wrapper.append(control); controls.push(wrapper);
      });
      this.refine.replaceChildren(...controls); this.refine.hidden = false;
      this.updateFilterTrigger();
      if (focusedKind) (this.refine.querySelector('[data-add-filter="' + focusedKind + '"]') || this.refine.querySelector('select') || this.input).focus();
    }
    buildFilterGroups(result, clearedKinds = new Set()) {
      const constraints = result.state?.constraints || [];
      const groups = [];
      filterDefinitions.forEach(definition => {
        const applied = constraints.find(c => c.kind === definition.kind) || null;
        if (definition.kind === 'size' && constraints.some(c => c.kind === 'frame_cm')) return;
        let options = definition.options || result.filters?.find(f => f.kind === definition.kind)?.options || [];
        if (definition.kind === 'size') {
          const order = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
          options = [...options].sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value));
        }
        if (definition.missingOnly && !applied && !clearedKinds.has(definition.kind) && !options.some(option => option.count < result.total)) return;
        if (applied && !options.some(option => String(option.value) === String(applied.value))) {
          options = [{ value: applied.value, label: applied.label, count: undefined }, ...options];
        }
        let range = null, custom = null;
        if (definition.kind === 'budget') {
          const min = constraints.find(c => c.kind === 'price_min')?.value;
          const max = constraints.find(c => c.kind === 'price_max')?.value;
          range = budgetRanges.find(candidate => candidate.min === min && candidate.max === max) || null;
          if (!range && (min !== undefined || max !== undefined)) custom = { value: 'custom', label: priceLabel(min, max) };
        }
        groups.push({ definition, options, applied, range, custom, desktopVisible: !(definition.missingOnly && applied) });
      });
      return groups;
    }
    updateFilterTrigger() {
      if (!this.filterTrigger) return;
      const available = (this.filterModel || []).some(group => group.options.length || group.custom);
      const count = this.filters?.querySelectorAll('[data-remove-filter]').length || 0;
      this.filterTrigger.hidden = !available;
      if (this.filterCount) { this.filterCount.textContent = count ? String(count) : ''; this.filterCount.hidden = !count; }
      this.filterTrigger.setAttribute('aria-label', count ? 'Filter + Sort, ' + count + ' active' : 'Filter + Sort');
    }
    openFilters() {
      if (!this.filterSheet || !this.filterFields) return;
      const groups = (this.filterModel || []).filter(group => group.options.length || group.custom);
      if (!groups.length) return;
      this.filterFields.replaceChildren(...groups.map(group => this.filterField(group)));
      this.paintSheet();
      this.sort.value = new URL(location.href).searchParams.get('sort') || 'relevance';
      this.paintSortValue();
      this.filterSheet.open();
    }
    paintSortValue() {
      const value = this.querySelector('[data-sort-value]') || this.filterSheet?.querySelector('[data-sort-value]');
      if (value) value.textContent = this.sort.selectedOptions[0]?.textContent || 'Relevance';
    }
    filterField(group) {
      const { definition, options, applied, range, custom } = group;
      const row = node('label', 'bike-filter-sheet__row'); row.dataset.filterRow = definition.kind;
      row.append(node('span', 'bike-filter-sheet__label', definition.label));
      const value = node('span', 'bike-filter-sheet__value'); value.dataset.filterValue = '';
      row.append(value);
      const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      caret.setAttribute('class', 'bike-filter-sheet__caret'); caret.setAttribute('viewBox', '0 0 12 12'); caret.setAttribute('fill', 'none'); caret.setAttribute('stroke', 'currentColor'); caret.setAttribute('stroke-width', '1.5'); caret.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS(caret.namespaceURI, 'path'); path.setAttribute('d', 'm3 4.5 3 3 3-3'); caret.append(path);
      row.append(caret);
      const select = node('select', 'bike-filter-sheet__select');
      select.dataset.sheetFilter = definition.kind;
      select.setAttribute('aria-label', definition.label);
      const empty = node('option', '', definition.empty); empty.value = ''; empty.dataset.label = definition.empty; select.append(empty);
      options.forEach(option => {
        const el = node('option', '', option.label + (option.count !== undefined ? ' (' + option.count + ')' : ''));
        el.value = option.value; el.dataset.label = option.label; select.append(el);
      });
      if (custom) {
        const el = node('option', '', 'Custom price range'); el.value = 'custom'; el.dataset.label = custom.label; select.append(el); select.value = 'custom';
      } else if (range) select.value = range.value;
      else if (applied) select.value = String(applied.value);
      select.disabled = !options.length && !custom;
      row.append(select);
      this.paintSheetRow(row);
      return row;
    }
    paintSheetRow(row) {
      const select = row.querySelector('select'); if (!select) return;
      const option = select.selectedOptions[0];
      const value = row.querySelector('[data-filter-value]');
      if (value) value.textContent = option ? (option.dataset.label || option.textContent) : '';
      row.dataset.filled = select.value ? 'true' : 'false';
      row.dataset.disabled = select.disabled ? 'true' : 'false';
    }
    paintSheet() {
      if (!this.filterFields) return;
      this.filterFields.querySelectorAll('[data-filter-row]').forEach(row => this.paintSheetRow(row));
      if (this.filterClear) this.filterClear.hidden = !this.filterFields.querySelector('[data-filled="true"]');
    }
    onSheetChange(event) {
      const row = event.target.closest?.('[data-filter-row]');
      if (!row || !this.filterFields?.contains(row)) return;
      this.sheetRequest?.abort();
      this.paintSheetRow(row);
      this.paintSheet();
    }
    async clearSheetFilters() {
      if (!this.filterFields) return;
      this.filterFields.querySelectorAll('select[data-sheet-filter]').forEach(select => { select.value = ''; });
      this.paintSheet();
      (this.filterFields.querySelector('select:not(:disabled)') || this.querySelector('[data-filter-close]'))?.focus();
      if (!this.state) return;
      // Refresh the draft's options without committing it to the results or URL.
      // Keep query constraints that aren't represented by sheet controls.
      const controlled = new Set(Array.from(this.filterFields.querySelectorAll('[data-sheet-filter]'), select => select.dataset.sheetFilter));
      if (controlled.has('budget')) { controlled.add('price_min'); controlled.add('price_max'); }
      const state = { ...this.state, constraints: this.state.constraints.filter(c => !controlled.has(c.kind)), notices: [] };
      state.originalQuery = label(state);
      const params = new URLSearchParams({ q: state.originalQuery, state: encode(state), page: '1', sort: this.sort.value });
      this.sheetRequest?.abort();
      const request = this.sheetRequest = new AbortController();
      const timeout = setTimeout(() => request.abort(), 10000);
      try {
        const response = await fetch(this.dataset.serviceUrl.replace(/\/$/, '') + '/search?' + params, { signal: request.signal });
        if (!response.ok) return;
        const result = await response.json();
        if (request.signal.aborted || this.sheetRequest !== request || !this.isConnected || this.filterSheet?.hidden !== false) return;
        const focusedKind = this.filterFields.contains(document.activeElement) ? document.activeElement.dataset.sheetFilter : null;
        const groups = this.buildFilterGroups(result, controlled).filter(group => group.options.length || group.custom || controlled.has(group.definition.kind));
        this.filterFields.replaceChildren(...groups.map(group => this.filterField(group)));
        this.paintSheet();
        if (focusedKind) this.filterFields.querySelector('[data-sheet-filter="' + focusedKind + '"]')?.focus();
      } catch {
        // Leave the cleared draft usable; applying it retries the results request.
      } finally {
        clearTimeout(timeout);
      }
    }
    previousFilterValue(kind, constraints) {
      if (kind === 'budget') {
        const min = constraints.find(c => c.kind === 'price_min')?.value;
        const max = constraints.find(c => c.kind === 'price_max')?.value;
        const range = budgetRanges.find(candidate => candidate.min === min && candidate.max === max);
        return range ? range.value : (min !== undefined || max !== undefined) ? 'custom' : '';
      }
      const applied = constraints.find(c => c.kind === kind);
      return applied ? String(applied.value) : '';
    }
    applySheetFilters() {
      if (!this.filterSheet) return;
      if (!this.state) { this.filterSheet.close(); return; }
      const selects = Array.from(this.filterFields.querySelectorAll('select[data-sheet-filter]'));
      const controlled = new Set();
      const chosen = selects.map(select => {
        const kind = select.dataset.sheetFilter;
        controlled.add(kind);
        if (kind === 'budget') { controlled.add('price_min'); controlled.add('price_max'); }
        const option = select.selectedOptions[0];
        return { kind, value: select.value, label: option ? (option.dataset.label || option.textContent) : '', empty: select.options[0]?.dataset.label || '' };
      });
      // A custom price pair is not one of the fixed ranges; keep it untouched.
      if (chosen.some(item => item.kind === 'budget' && item.value === 'custom')) { controlled.delete('price_min'); controlled.delete('price_max'); }
      const previous = this.state.constraints;
      const constraints = previous.filter(c => !controlled.has(c.kind));
      const interactions = [];
      chosen.forEach(item => {
        if (item.value === this.previousFilterValue(item.kind, previous)) {
          const kinds = item.kind === 'budget' ? ['price_min', 'price_max'] : [item.kind];
          constraints.push(...previous.filter(c => controlled.has(c.kind) && kinds.includes(c.kind)));
          return;
        }
        interactions.push({ action: item.value ? 'select' : 'clear', source: 'sheet', filter_kind: item.kind, filter_value: item.value, filter_label: item.value ? item.label : item.empty });
        if (item.kind === 'budget') {
          const range = budgetRanges.find(candidate => candidate.value === item.value);
          if (range?.min !== undefined) constraints.push({ kind: 'price_min', value: range.min, label: 'From ' + money(range.min), key: 'price_min:' + range.min });
          if (range?.max !== undefined) constraints.push({ kind: 'price_max', value: range.max, label: 'Up to ' + money(range.max), key: 'price_max:' + range.max });
        } else if (item.value) {
          constraints.push({ kind: item.kind, value: item.value, label: item.label, key: item.kind + ':' + item.value });
        }
      });
      const sortValue = this.sort.value;
      const sortChanged = sortValue !== (new URL(location.href).searchParams.get('sort') || 'relevance');
      this.filterSheet.close();
      if (interactions.length || sortChanged) this.commitFilters(constraints, interactions, sortValue);
    }
    renderAppliedFilters(state) {
      const focusedKey = this.filters.contains(document.activeElement) ? document.activeElement.dataset.removeFilter : null;
      this.filters.replaceChildren();
      const prices = state.constraints.filter(c => ['price_min', 'price_max'].includes(c.kind));
      const range = budgetRanges.find(range => range.min === prices.find(c => c.kind === 'price_min')?.value && range.max === prices.find(c => c.kind === 'price_max')?.value);
      const chips = state.constraints.filter(c => !range || !['price_min', 'price_max'].includes(c.kind)).map(c => ({ key: c.key, label: c.label }));
      if (range) chips.push({ key: prices.map(c => c.key).join('|'), label: range.label });
      chips.forEach(c => {
        const button = node('button', 'bike-search-filter', c.label); button.type = 'button'; button.dataset.removeFilter = c.key; button.setAttribute('aria-label', 'Remove ' + c.label + ' filter');
        const cross = node('span', '', ' ×'); cross.setAttribute('aria-hidden', 'true'); button.append(cross); this.filters.append(button);
      });
      this.updateFilterTrigger();
      if (focusedKey) (this.filters.querySelector('[data-remove-filter]') || this.refine?.querySelector('select') || this.input).focus();
    }
    trimBadges() {
      this.grid.querySelectorAll('.product-badges').forEach(container => {
        const badges = Array.from(container.children);
        badges.forEach((badge, index) => { badge.hidden = index >= 3; });
        const gap = parseFloat(getComputedStyle(container).columnGap) || 5;
        let used = 0, full = false;
        badges.slice(0, 3).forEach((badge, index) => {
          const width = badge.getBoundingClientRect().width + (index ? gap : 0);
          if (full || used + width > container.clientWidth) { badge.hidden = true; full = true; }
          else used += width;
        });
      });
    }
    showSkeletons() {
      const cards = Array.from({ length: 8 }, () => {
        const row = node('li', 'product-grid__item bike-search-skeleton');
        row.setAttribute('aria-hidden', 'true');
        row.append(node('div', 'bike-search-skeleton__image'));
        const details = node('div', 'bike-search-skeleton__details');
        const badges = node('div', 'bike-search-skeleton__badges');
        badges.append(node('span', 'bike-search-skeleton__block'), node('span', 'bike-search-skeleton__block'));
        details.append(badges, node('span', 'bike-search-skeleton__block bike-search-skeleton__title'), node('span', 'bike-search-skeleton__block bike-search-skeleton__price'));
        row.append(details);
        return row;
      });
      this.grid.replaceChildren(...cards);
      this.pagination.replaceChildren();
    }
    renderPagination(result) {
      this.pagination.replaceChildren();
      const totalPages = Math.ceil(result.total / result.pageSize);
      if (totalPages <= 1) return;
      const control = (text, page, direction) => {
        const enabled = page >= 1 && page <= totalPages;
        const link = node(enabled && (direction || page !== result.page) ? 'a' : 'span', 'bike-search-page' + (enabled ? '' : ' bike-search-page--disabled'));
        if (enabled && (direction || page !== result.page)) {
          const url = new URL(location.href); url.searchParams.set('page', page);
          link.href = url.pathname + url.search;
          if (direction) link.rel = direction;
        } else if (!enabled) link.setAttribute('aria-disabled', 'true');
        if (direction) {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.5'); svg.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS(svg.namespaceURI, 'path');
          path.setAttribute('d', direction === 'prev' ? 'M19 12H5m7-7-7 7 7 7' : 'M5 12h14m-7-7 7 7-7 7');
          svg.append(path);
          link.setAttribute('aria-label', text);
          link.append(svg);
        } else {
          link.textContent = text; link.classList.add('bike-search-page--number');
          link.setAttribute('aria-label', 'Page ' + page);
          if (page === result.page) { link.removeAttribute('href'); link.setAttribute('aria-current', 'page'); }
        }
        this.pagination.append(link);
      };
      control('Previous', result.page - 1, 'prev');
      const pages = [...new Set([1, result.page - 1, result.page, result.page + 1, totalPages])].filter(page => page >= 1 && page <= totalPages).sort((a, b) => a - b);
      pages.forEach((page, index) => {
        if (index && page - pages[index - 1] > 1) this.pagination.append(node('span', 'bike-search-pagination__ellipsis', '…'));
        control(String(page), page);
      });
      control('Next', result.page + 1, 'next');
    }
    async load() {
      this.sheetRequest?.abort();
      const sequence = ++this.sequence; this.request?.abort(); clearTimeout(this.timeout); this.request = new AbortController(); this.timeout = setTimeout(() => this.request.abort(), 10000);
      const url = new URL(location.href), query = url.searchParams.get('q') || ''; this.input.value = query; this.sort.value = url.searchParams.get('sort') || 'relevance';
      this.sort.title = 'Sort by: ' + (this.sort.selectedOptions[0]?.textContent || 'Relevance');
      this.status.textContent = ''; this.refine?.querySelectorAll('select').forEach(select => { select.disabled = true; }); this.showSkeletons(); this.error.hidden = true; this.setAttribute('aria-busy', 'true');
      if (url.searchParams.has('bike_state')) { try { this.state = JSON.parse(decodeURIComponent(escape(atob(url.searchParams.get('bike_state').replace(/-/g, '+').replace(/_/g, '/'))))); } catch { this.state = null; } } else { this.state = null; this.filters.replaceChildren(); }
      const params = new URLSearchParams({ q: query, page: url.searchParams.get('page') || '1', sort: this.sort.value });
      if (url.searchParams.has('bike_state')) params.set('state', url.searchParams.get('bike_state'));
      try {
        const response = await fetch(this.dataset.serviceUrl.replace(/\/$/, '') + '/search?' + params, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const result = await response.json(); if (sequence !== this.sequence || !this.isConnected) return;
        this.state = result.state;
        // Pin the interpreted state in the URL: back navigation must retain it.
        if (!url.searchParams.has('bike_state')) { url.searchParams.set('bike_state', encode(result.state)); history.replaceState({}, '', url); }
        this.renderRefinements(result);
        this.renderAppliedFilters(result.state);
        const cards = await Promise.all((result.products || []).map(product => this.card(product)));
        if (sequence !== this.sequence || !this.isConnected) return;
        this.grid.replaceChildren(...cards.filter(Boolean));
        this.trimBadges();
        this.status.textContent = result.total ? '' : 'No bikes match these filters. Try removing a filter or changing your search.';
        if (result.state.notices?.length) this.status.textContent += ' ' + result.state.notices.join('. ');
        this.renderPagination(result);
      } catch (error) {
        if (sequence !== this.sequence) return;
        this.grid.replaceChildren(); this.status.textContent = 'Search is temporarily unavailable.'; this.error.hidden = false; this.pagination.replaceChildren();
        const standard = this.querySelector('[data-standard-search]'); standard.href = (this.dataset.searchRoute || '/search') + '?' + new URLSearchParams({ q: query, type: 'product', standard_search: '1', view: 'standard-search' });
      } finally { if (sequence === this.sequence) { clearTimeout(this.timeout); this.removeAttribute('aria-busy'); } }
    }
    async card(product) {
      const row = node('li', 'product-grid__item product-grid__item--product'); row.dataset.productId = product.id;

      const handle = String(product.handle || String(product.url || '').match(/\/products\/([^/?#]+)/)?.[1] || '');
      const productPath = handle && !/[/?#]/.test(handle) ? '/products/' + encodeURIComponent(handle) : '#';
      const signal = this.request?.signal;
      if (productPath !== '#') {
        try {
          const response = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=bike-finder-product-card', { signal });
          if (response.ok) {
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const sharedCard = parsed.querySelector('loess-product-card.card, .card');
            if (sharedCard) {
              row.append(document.importNode(sharedCard, true));
              return row;
            }
          }
        } catch (error) {
          if (signal?.aborted && (!this.isConnected || this.request?.signal !== signal)) return null;
        }
      }

      const card = node('div', 'card bike-search-card'); const media = node('div', 'card__image-wrapper');
      const link = node('a', 'card__image bike-search-card__image'); link.href = productPath;
      if (product.image) { try { const url = new URL(product.image); if (url.protocol === 'https:') { const image = node('img'); image.src = url.href; image.alt = product.title; image.loading = 'lazy'; image.width = 640; image.height = 480; link.append(image); } } catch {} }
      media.append(link);
      const wishlist = node('button', 'product-card-wishlist'); wishlist.type = 'button'; wishlist.setAttribute('aria-label', 'Add to Wishlist'); wishlist.dataset.productCardWishlist = ''; wishlist.dataset.productId = product.id; wishlist.dataset.customerLoggedIn = this.dataset.customerLoggedIn || 'false';
      if (this.dataset.customerEmail) { wishlist.dataset.customerEmail = this.dataset.customerEmail; wishlist.dataset.customerToken = this.dataset.customerToken; }
      // Static authored icon: product text never enters HTML.
      wishlist.innerHTML = '<svg class="product-card-wishlist__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="product-card-wishlist__count" data-wishlist-count></span>';
      media.append(wishlist); card.append(media);
      const details = node('div', 'card__metadata'); const title = node('a', 'card__title small-body-text', product.title); title.href = productPath; details.append(title);
      const specs = [product.size, product.year].filter(Boolean); if (specs.length) { const badges = node('div', 'product-badges'); specs.forEach(spec => badges.append(node('span', '', spec))); details.prepend(badges); }
      details.append(node('p', 'bike-search-card__price', new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(product.price_gbp)));
      card.append(details); row.append(card); return row;
    }
  }
  customElements.define('mnb-bike-search-results', BikeResults);
})();
